import { createFileRoute } from '@tanstack/react-router';

import { AdminSportHubPage } from '@/components/admin/sport/hub-page';
import { adminHead } from '@/lib/seo';
import { adminSportHubFn } from '@/server/functions/sport';

export const Route = createFileRoute('/_admin/admin/sport/')({
    component: SportHubRoute,
    head: () => adminHead('ספורט', '/admin/sport'),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: () => adminSportHubFn(),
});

function SportHubRoute() {
    const data = Route.useLoaderData();
    return <AdminSportHubPage initial={data} />;
}
